module.exports = __webpack_public_path__ + "static/media/06A.13d330e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/06A.png
// module id = 254
// module chunks = 0